import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["placement", "delay", "variant", "p", "fontSize"];
import React from 'react';
import Tooltip from 'components/Tooltip';
function Dropdown(_ref) {
  var _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'raised' : _ref$variant,
    _ref$p = _ref.p,
    p = _ref$p === void 0 ? 0 : _ref$p,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 'm' : _ref$fontSize,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    placement: placement,
    delay: delay,
    variant: variant,
    p: p,
    fontSize: fontSize
  }, otherProps));
}
export default Dropdown;